<template>
    <div @click="clickCampaign()">
        <div class="wrapper-campaign-item" v-if="(type != 'review' && type != 'survey' && type != 'surveydraw' && !isReward)">
            <div class="wrapper-campaign">
                <div class="wrapper-img-campaign">
                    <div class="img-flag" v-if="campaign.qty <= 0">สิทธิ์เต็ม</div>
                    <div class="img-filter" v-if="campaign.qty <= 0"></div>
                    <div class="img-campaign">
                        <img :src="campaign.fullImageUrl"
                            class="card-img-top" />
                    </div>
                </div>

                <div class="wrapper-info">
                    <div class="campaign-name">{{campaign.name}}</div>
                    <!-- <div class="point">{{getPointMessage()}}</div> -->
                    <div class="wrapper-campaign-point">
                        <div class="campaign-point">
                            <div class="text">
                                <span class="use-point">
                                    {{ isShowBaht ?  campaign.maximumPartialPoints : campaign.pointPerUnit | number_format }}
                                    <!-- {{campaign.pointPerUnit | number_format}} -->
                                    </span>
                                <span>
                                    <img class="icon-point" src="@/assets/icon/reward_icon_coin@3x.png" />
                                </span>
                            </div>
                        </div>
                        <div class="campaign-baht" v-if="isShowBaht">
                            + {{ campaign.maximumPartialPrice | number_format }} {{ lbl.unit_price }}
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div v-if="type == 'review' || type == 'survey' || type == 'surveydraw'"
            :class="{'product-review-item' : type == 'review', 
                    'survey-item' : type == 'survey' || type == 'surveydraw' }">
            <div class="img">
                <img :src="campaign.fullImageUrl" />
                <!-- <img :src="`${pictureUrl}/Sensibio H2O F250ml sans parfum LD@3x.png`"/> -->
            </div>
            <div class="detail">
                <div class="text-name">{{campaign.name}}</div>
                <div class="wrapper-point">
                    <div class="box-point" v-if="!(type == 'surveydraw' && campaign.pointPerUnit == 0)">
                        <div class="text-get">{{lbl.get}}</div>
                        <div class="product-point">
                            <div class="text">
                            <span class="use-point" >{{campaign.pointPerUnit | number_format}}</span>
                                <span>
                                    <img class="icon-point" src="@/assets/icon/reward_icon_coin@3x.png" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="btn-review">
                    รีวิว
                </div> -->
            </div>
        </div>
        <div v-if="isReward" class="wrapper-campaign-item">
            <div class="wrapper-campaign-reward">
                <div class="wrapper-img-campaign">
                    <div class="img-flag" v-if="campaign.qty <= 0">สิทธิ์เต็ม</div>
                    <div class="img-filter" v-if="campaign.qty <= 0"></div>
                    <div class="img-campaign">
                        <img class="card-img-top" :src="campaign.fullImageUrl" />
                    </div>
                </div>
                <div class="wrapper-info-reward">
                    <div class="campaign-name-reward">{{campaign.name}}</div>
                    <div class="campaign-baht" v-if="isShowBaht">
                        + {{ campaign.maximumPartialPrice | number_format }} {{ lbl.unit_price }}
                    </div>
                </div>
            </div>
            <div class="divider divider-color-ground"></div>
            <div class="wrapper-point">
                <div class="campaign-point">
                    <div class="text">
                        <div class="use-point">
                            <div v-if="isShowBaht">{{ lbl.use }} {{ campaign.maximumPartialPoints | number_format }}</div>
                            <div v-else>{{ usePoint() }}</div>
                        </div>
                        <img class="icon-point" src="@/assets/icon/reward_icon_coin@3x.png" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Locale from "@/helper/locale/locale.js"
import CacheHelper from "@/helper/CacheHelper.js";
import Util from '@/helper/Utility.js';
export default {
    name: 'CampaignItem',
    props: {
        lbl: Object,
        index: Number,
        campaign: Object,
        type: String,
        tracking: Object,
        trackingEvent: String,
        isReward: Boolean,
    },
    data: function() {
        return {
        }
    },
    computed: {
        isShowBaht: function () {
            return (this.campaign.type == Vue.CampaignType.Privilege);
        },
    },
    created: function() {
        // console.log('lblCampaign',this.lbl);
    },
    mounted: function () {
        //this.lblCampaign = this.lbl.campaign;
    },
    methods: {
        //event
        clickCampaign: function () {
            var cache = new CacheHelper('session');
            if(cache.getCache('isFromBDM')){
                cache.removeCache('isFromBDM');
            }

            var path = '/reward/' + this.campaign.id;
            this.$router.push(path);

            //tracking
            let trackCamp = this.campaign.id + "|" + this.campaign.name;
            switch (this.trackingEvent) {
                case 'home':
                    this.tracking.event('home_reward_campaign', 'click_home_reward_campaign', trackCamp);
                    break;
                case 'reward':
                    this.tracking.event('click_reward_campaign', 'click_reward_campaign', trackCamp);
                    break;
            }
        },
        //method
        isSoldOut: function () {
            return this.campaign.qty < 1
                ? true
                : false
        },
        //utility
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lblCampaign.get_point : this.lblCampaign.use_point;
            var pointUnit = this.lblCampaign.point + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        },
        usePoint: function () {
            let pointUnit = ""
            let pointText = "";

            if(this.campaign.type == Vue.CampaignType.Buy) {
                pointText = this.lbl.add_to_cart

            }else if (this.campaign.type == Vue.CampaignType.Event || this.campaign.type == Vue.CampaignType.News
                || this.campaign.type == Vue.CampaignType.Media) {
                pointText = this.lbl.see_detail;

            }else {
                if(this.campaign.pointPerUnit <= 0 ){
                    pointText = this.lbl.free
                }else{
                    if(this.campaign.pointType == 'use'){
                        pointUnit = this.lbl.use + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
                        pointText = `${pointUnit} ${Util.formatNum(this.campaign.pointPerUnit)}`;
                    }else if(this.campaign.pointType != 'use'){
                        pointUnit = this.lbl.get + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
                        pointText = `${pointUnit} ${Util.formatNum(this.campaign.pointPerUnit)}`;
                    }else{
                        pointText = this.lbl.see_detail
                    }
                }
            }
            return pointText
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseImage.scss";
@import "@/style/base/baseText.scss";
@import "@/style/base/baseDisplay.scss";
@import "./campaignItem.scss";

</style>
